import { Injectable } from '@angular/core';

import {environment} from '@app/environment';

@Injectable({
  providedIn: 'root'
})
export class DemoozLocalStorageService {
    
    constructor() { }
    
    set(key: string, value: any) {
        key = this.checkKeyName(key);
        if(typeof value === 'object'){
            value = JSON.stringify(value);
        }
        localStorage.setItem(key, value);
    }
    
    get(key: string, isObject: boolean = false) {
        key = this.checkKeyName(key);
        let value = localStorage.getItem(key);
        return (isObject && value ? JSON.parse(value) : value);
    }
    
    delete(key: string){
        key = this.checkKeyName(key);
        localStorage.removeItem(key);
    }
    
    checkKeyName(key: string){
        let regex = new RegExp('^'+environment.PREFIX_LOCALSTORAGE+'_');
        if(!regex.test(key)){
            key = environment.PREFIX_LOCALSTORAGE+'_'+key;
        }
        return key;
    }
}
